import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CprResultEffect } from './cpr-result.effect';
import { cprResultReducer } from './cpr-result.reducer';
import { CPR_RESULT_STORE_NAME, CprResultState } from './cpr-result.state';

/** Token of the CprResult reducer */
export const CPR_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<CprResultState, Action>>(
  'Feature CprResult Reducer'
);

/** Provide default reducer for CprResult store */
export function getDefaultCprResultReducer() {
  return cprResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CPR_RESULT_STORE_NAME, CPR_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([CprResultEffect]),
  ],
  providers: [{ provide: CPR_RESULT_REDUCER_TOKEN, useFactory: getDefaultCprResultReducer }],
})
export class CprResultStoreModule {
  public static forRoot<T extends CprResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CprResultStoreModule> {
    return {
      ngModule: CprResultStoreModule,
      providers: [{ provide: CPR_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
